import React from "react";
import { Modal } from "semantic-ui-react";

const KeyFindingModals = ({
  // Card finding states
  card_finding_1,
  card_finding_2,
  card_finding_3,
  card_finding_4,
  card_finding_5,
  card_finding_6,

  // Key finding states
  key_finding_1,
  key_finding_2,
  key_finding_3,
  key_finding_p,
  key_finding_t,
  info_table,
  toolkit,

  // Handlers
  handleCardClose,
  handleKeyClose,

  // Data props
  key_finding_data,
  analysis,
  rcp,
  ssp,
  year,
  overall,
  losses,
  hazard,
}) => {
  return (
    <>
      {/* Card Finding Modals */}
      <Modal open={card_finding_1} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Maximum Exposure
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            Maximum Asset Exposure is the combined valuation including content
            value (when selected) and operational exposure of all the assets
            that have a material exposure to climate events (loss &gt; 0),
            expressed in dollar terms.
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={toolkit} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Adaptation Toolkits
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            <br />
            <ol>
              <li>
                Adaptation Toolkits: Provide a guidance for overall
                understanding of key concept in relation to adaptation and
                resilience action, adaptation planning process, as well as
                categories and example in general.
              </li>
            </ol>
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={card_finding_2} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Value of Transition Policies
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            reflects the cost-saving benefits from the reduced physical climate
            risk that will occur if appropriate steps are taken now to implement
            climate action and policies toward a net-zero emissions target. It
            is the difference in the portfolio Climate Value-at-Risk between
            that of a high emissions scenario (RCP 8.5/SSP 5-8.5) and the
            net-zero emissions scenario (RCP 2.6/SSP 1-2.6) for a specified time
            horizon.
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={card_finding_3} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Climate Value at Risk
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            Climate Value-at-Risk (CVaR) is defined as the maximum amount of
            physical, operational and inventory loss to be incurred over one
            year, given the co-occurrence of extreme events (for all climate
            hazards that affect the asset). This depends on factors that include
            hazard severity, the area of the building, the replacement cost, the
            building use characteristics and the vulnerability to a specific
            hazard through damage functions.
            <br />
            Climate Value-at-Risk (CVaR in %) is the CVaR (sum of potential
            physical, operational inventory losses on the asset in present-day
            US dollar terms) divided by the maximum asset exposure (the combined
            valuation, operational and inventory exposure), expressed in
            percentage terms.
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={card_finding_4} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Climate Score
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            reflects the equally weighted average of climate hazard severity
            across all hazards and all assets analyzed within a portfolio.
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={card_finding_5} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Total Asset Value
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            Total Asset Value is the combined valuation, operational and
            inventory exposure of all the assets expressed in dollar terms.
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={card_finding_6} onClose={handleCardClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Residual Climate value at Risk
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            Residual Climate Value at Risk refers to climate value-at-risk net
            of surrounding and asset-level adaptations and mitigations. It is
            the realised risk left with the owner/operator of the asset due to
            residual exposure to extreme weather events.
          </p>
        </Modal.Content>
      </Modal>

      {/* Key Finding Modals */}
      <Modal open={key_finding_1} onClose={handleKeyClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Key Findings
        </Modal.Header>
        <Modal.Content>
          {key_finding_data ? (
            <p className="key_finding">
              For {analysis?.toUpperCase()}{" "}
              {analysis === "rcp" ? <span>{rcp}</span> : <span>{ssp}</span>},
              Climate Value at Risk of{" "}
              {key_finding_data.cvar_85_perc?.toFixed(2)}% means that by {year}{" "}
              in any given one year{" "}
              {year === "2100" ? (
                <span>
                  ({year - 19}-{year})
                </span>
              ) : (
                <span>
                  ({year - 9}-{year + 10})
                </span>
              )}
              , we expect there to be a 1% chance that{" "}
              {key_finding_data.cvar_85_perc?.toFixed(2)}% of the US$
              {overall?.["Max_exposure"]?.toFixed(2)} Million results in a
              maximum loss of US${""}
              {losses?.["total"]?.["Total Loss"]?.[0]?.toFixed(2)} Million.
            </p>
          ) : null}
        </Modal.Content>
      </Modal>

      <Modal open={key_finding_p} onClose={handleKeyClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Portfolio Exposure related Loss Analysis
        </Modal.Header>
        <Modal.Content>
          <ul style={{ listStyleType: "disc", padding: "1%" }}>
            <li>
              Total CVaR in % = Total CVaR / Portfolio Exposure (i.e. Total
              asset value + total annual revenue income of ALL assets in the
              portfolio disregard if any asset is not exposed to any hazard
              damage.)
            </li>
            <li>
              Damage CVaR in % = Total Physical damage loss / total asset value
              for ALL assets in the portfolio
            </li>
            <li>
              Operational CVaR in % = Total operational loss / total annual
              revenue income for ALL assets in the portfolio
            </li>
          </ul>
        </Modal.Content>
      </Modal>

      <Modal open={key_finding_t} onClose={handleKeyClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Technical Insurance Premium
        </Modal.Header>
        <Modal.Content>
          <p>
            Technical Insurance Premium (TIP) is the annual expected cost of
            damage assuming all hazards are insured, which is equal to the
            physical loss of the asset, using the replacement cost as the basis.
            TIP in % is the TIP as a percentage of the replacement cost of the
            asset.
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={key_finding_2} onClose={handleKeyClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Key Findings
        </Modal.Header>
        <Modal.Content>
          {hazard ? (
            <p className="key_finding">
              For the assets analyzed, the portfolio is exposed to chronic &
              acute climate events to the extent identified below. The red bar
              above each hazard indicates the severity of that hazard for the
              year 2020 (historical), and the blue bar indicates the severity of
              that hazard by the year under consideration (e.g., by the year{" "}
              {analysis === "rcp" ? (
                <span>2030 / 2050</span>
              ) : (
                <span>2030/2050/2100</span>
              )}
              ). Users can compare the length of the red bar with the blue bar
              to get a sense of how the risk severity for each hazard changes
              across years.
              <br />
              <br />
              {hazard.both?.["Typhoon"] ? (
                <p>
                  <span className="variable_heading">
                    Typhoon : {hazard.both["Typhoon"][0]}
                    {hazard.both["Typhoon"][1]}
                  </span>{" "}
                  &nbsp; Typhoons bring intense wind gusts and rainfall that may
                  result in physical damage to assets, power outages and
                  business interruption. Typhoon risk models estimate the
                  spatial extent and wind speed intensity of a typhoon from
                  historic tropical cyclone track, temperature and wind speed
                  data.
                </p>
              ) : null}
              <br />
              {hazard.both?.["Rainfall Flood"] ? (
                <p>
                  <span className="variable_heading">
                    Rainfall Flood : {hazard.both["Rainfall Flood"][0]}
                    {hazard.both["Rainfall Flood"][1]}
                  </span>{" "}
                  &nbsp; Rainfall flood refers to inundation resulting from
                  rainfall, elevation and climate change. Flood hazard severity
                  is derived from flood models, river bathymetry, maximum
                  rainfall in a 24-hour period, and extreme rainfall
                  events.​Intense precipitation may bring rainfall floods or
                  storm surges that result in physical damages to assets or
                  temporary facility closures.
                </p>
              ) : null}
              <br />
              {hazard.both?.["River Flood"] ? (
                <p>
                  <span className="variable_heading">
                    River Flood : {hazard.both["River Flood"][0]}
                    {hazard.both["River Flood"][1]}{" "}
                  </span>{" "}
                  &nbsp; River flood refers to inundation as a result of
                  overflows from a river channel. This may result in physical
                  damage to assets and business interruption. Flood hazard
                  information is obtained from in-house hydrology and hydraulic
                  models.​
                </p>
              ) : null}
              <br />
              {hazard.both?.["Extreme heat"] ? (
                <p>
                  {" "}
                  <span className="variable_heading">
                    Extreme Heat : {hazard.both["Extreme heat"][0]}
                    {hazard.both["Extreme heat"][1]}
                  </span>{" "}
                  &nbsp; Extreme Heat is experienced when humidity and
                  temperature are high for prolonged period. Extreme heat values
                  reflected are maximum values derived from the impacts of
                  climate change on temperature and relative humidity. Prolonged
                  extreme heat conditions may lead to undesirable effects on
                  health and well-being, productivity losses and increased
                  energy consumption.
                </p>
              ) : null}
              <br />
              {hazard.both?.["Sea Level Rise"] ? (
                <p>
                  {" "}
                  <span className="variable_heading">
                    Sea Level Rise : {hazard.both["Sea Level Rise"][0]}
                    {hazard.both["Sea Level Rise"][1]}{" "}
                  </span>{" "}
                  &nbsp;Sea Level Rise refers to inundation estimated from
                  shoreline and elevation models. It considers mean sea level
                  projections, the affected catchment area near shorelines,
                  elevation models and forecasting analysis based on the
                  representative scenarios from Global Circulation Models.​ Sea
                  level rise as a chronic hazard may result in inundation of
                  areas or road networks surrounding an asset over a long time
                  horizon.
                </p>
              ) : null}
              <br />
              {hazard.both?.["Storm Surge"] ? (
                <p>
                  {" "}
                  <span className="variable_heading">
                    Storm Surge : {hazard.both["Storm Surge"][0]}
                    {hazard.both["Storm Surge"][1]}
                  </span>{" "}
                  &nbsp; Storm surge refers to the extreme rise in sea level due
                  to typhoons, typhoon tracks, elevations, and climate change.
                  This may result in physical damage to assets and business
                  interruption. Storm surge hazard inundation depths are derived
                  from hydrodynamic models.
                </p>
              ) : null}
              <br />
              {hazard.both?.["Snow Fall"] ? (
                <p>
                  {" "}
                  <span className="variable_heading">
                    Snowfall : {hazard.both["Snow Fall"][0]}
                    {hazard.both["Snow Fall"][1]}{" "}
                  </span>{" "}
                  &nbsp; Precipitation in the form of snow it is derived from
                  CMIP6 GCM models. it is expressed in units of kg m⁻² s⁻¹,
                  which is equivalent to mm/s (assuming a water density of 1000
                  kg/m³). To analyze snowfall over time, daily snowfall data is
                  aggregated to calculate the annual cumulative snowfall,
                  represented in mm/yr. The data is further processed to compute
                  aggregated means for specific CMIP6 timelines, such as 2030,
                  2050, and 2100. This dataset is particularly valuable for
                  studying hydrological impacts of climate change and assessing
                  avalanche risks in mountainous regions with extreme snowfall
                </p>
              ) : null}
              <br />
              {hazard.both?.["Landslide"] ? (
                <p>
                  {" "}
                  <span className="variable_heading">
                    Landslide : {hazard.both["Landslide"][0]}
                    {hazard.both["Landslide"][1]}{" "}
                  </span>{" "}
                  &nbsp; A landslide is a movement of a mass of rock, debris, or
                  earth down a slope. The hazard is calculated as a frequency or
                  annual probability of landslide.
                </p>
              ) : null}
              <br />
              {hazard.both?.["Drought"] ? (
                <p>
                  {" "}
                  <span className="variable_heading">
                    Drought : {hazard.both["Drought"][0]}
                    {hazard.both["Drought"][1]}
                  </span>{" "}
                  <br />
                  Drought is a prolonged absence or marked deficiency of
                  precipitation or dry weather which results in water shortage
                  or a hydrological imbalance. Drought scores are derived from
                  the Standard Precipitation Index.
                  <br />A negative number indicates a drought, meaning it is
                  drier. A positive number indicates wetter conditions.
                </p>
              ) : null}
              <br />
              <p>
                Note :: Above hazard values are averages across all assets
                within the portfolio
              </p>
            </p>
          ) : null}
        </Modal.Content>
      </Modal>

      <Modal open={key_finding_3} onClose={handleKeyClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Key Findings
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            Users can compare the length of the red bar with the blue bar to
            visualize changes in the Climate Value-at-Risk (financial loss in
            dollar or % value) across dimensions.
            <br />
            <b>Per Hazard</b>: The ratio is calculated as hazard-specific total
            loss divided by the maximum exposure that includes physical,
            exposure and inventory <br />
            <b>Detailed</b>: The ratio is calculated as hazard-specific loss on
            damage or operation divided by the respective exposure on physical
            risk, or operational exposure <br />
            <b>Overall</b>: The ratio is calculated as hazard-specific loss on
            damage/operation/inventory divided by the respective exposure on
            physical risk/operational/inventory exposure
          </p>
        </Modal.Content>
      </Modal>

      <Modal open={info_table} onClose={handleKeyClose} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Asset Table
        </Modal.Header>
        <Modal.Content>
          <p className="key_finding">
            Users can use the "Edit" function for each asset under the "Action"
            column to update different variables, including asset name, property
            type, area (single floor construction area in square meter), floors
            (total no. of floors), value (asset valuation per square meter),
            etc. So as long as the user is within its subscription period, the
            analysis results can be updated with more accurate internal
            information when this information is available later. However, the
            location information (latitude and longitude) can not be updated
            once the project is created. Simply amend the content of the
            variables and click "Save", the analysis results will update
            accordingly.
          </p>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default KeyFindingModals;
